import React from 'react';

const TableInfoApprovedBenefits = ({ info }) => {
  return (
    <div className="container-fluid mt-4">
      <div className="container">
        <div className="table-responsive">
          <table className="table table-striped table-hover" id='tableMainInfoGroupForCopy'>
            <thead className="table-dark">
              <tr>
                <th scope="col">Свідоцтво</th>
                <th scope="col">Дата заявки</th>
                <th scope="col">Пільга ID</th>
                <th scope="col">Дата оновлення пільги</th>
              </tr>
            </thead>
            <tbody>
              {info.map((el, index) => (
                <tr key={index}>
                  <td>{el.child.birthCertificate.number}</td>
                  <td>{new Date(el.createdAt).toLocaleDateString()}</td>
                  <td>{el.child.benefits[0].benefitId}</td>
                  <td>{new Date(el.child.benefits[0].updatedAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableInfoApprovedBenefits;